import React from 'react';
import type { FormCustomNode } from '../../types/layout';
import { useFormEngineForm, useFormEngineState } from '../../context/FormEngineContext';

interface FormCustomNodeRendererProps {
  node: FormCustomNode;
}

export const FormCustomNodeRenderer = React.memo(function FormCustomNodeRenderer({
  node,
}: FormCustomNodeRendererProps): React.ReactElement | null {
  const { form } = useFormEngineForm();
  const { meta, customRenderers } = useFormEngineState();

  const Renderer = customRenderers?.[node.rendererKey];
  if (!Renderer) {
    console.warn(`[form-engine] No custom renderer registered for key: ${node.rendererKey}`);
    return null;
  }

  return (
    <Renderer
      props={node.props ?? {}}
      control={form.control}
      meta={meta}
      getValues={form.getValues}
      setValue={(name, value) => form.setValue(name as any, value)}
    />
  );
});
